import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { BaseHttpService } from '../../services/common/base.http.service';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { administrationConst } from '../administration.const';
import { ResultInfo } from '../../shared/models/result-info.model';
import { EmployeeCategoryModel } from '../models/emloyee-categories.model';
import { ManageEmployeeCategoryModel } from '../models/manage-employee-category.model';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { SearchEmployeeCategoriesChanges } from '../models/search-employee-categories-changes.model';
import { EmployeeCategoryChangesModel } from '../models/employee-categories-changes.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeeCategoriesService {
  baseHttpService = inject(BaseHttpService);
  loggedInUserService = inject(LoggedInUserService);
  userEmail: string;
  
  searchEmployeeCategories(): Observable<EmployeeCategoryModel[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.get<EmployeeCategoryModel[]>(administrationConst.employeeCategory, { headers: headers });
  }

  searchEmployeeCategory(code: string): Observable<EmployeeBankAccountModel> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });    
    return this.baseHttpService.get<EmployeeBankAccountModel>(administrationConst.employeeCategory + "/" + code);
  }

  addEmployeeCategory(data: ManageEmployeeCategoryModel): Observable<ResultInfo>{    
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post(administrationConst.employeeCategory, data, { headers: headers });
  }

  updateEmployeeCategory(data: ManageEmployeeCategoryModel): Observable<ResultInfo>{    
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.put(administrationConst.employeeCategory, data, { headers: headers });
  }

  deleteEmployeeCategory(code: string): Observable<ResultInfo>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.delete(administrationConst.employeeCategory + "/" + code, { headers: headers });
  }

  seachEmployeeCategoriesChanges(searchParameters: SearchParameters<SearchEmployeeCategoriesChanges>): Observable<PagedResult<EmployeeCategoryChangesModel[]>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post<PagedResult<EmployeeCategoryChangesModel[]>>(administrationConst.employeeCategoryChanges, searchParameters, { headers: headers });
  } 
}